import {
  DELIVERY_NOTE_LIST,
  DELIVERY_NOTE_LIST_CLEAR,
  DELIVERY_NOTE_DATE_FILTER,
  DELIVERY_NOTE_CUSTOMER_FILTER
} from '../../mutationTypes'

const mutations = {
  [DELIVERY_NOTE_LIST](state, action) {
    state.items = action.items;
  },
  [DELIVERY_NOTE_LIST_CLEAR](state) {
    state.items = [];
  },
  [DELIVERY_NOTE_DATE_FILTER](state, action) {
    state.filter.date = action.date;
  },
  [DELIVERY_NOTE_CUSTOMER_FILTER](state, action) {
    state.filter.customerId = action.customerId;
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./client/store/modules/deliveryNote/deliveryNoteMutations.js